const defaultFormats = {
  webp: 'image/webp',
  jpg: 'image/jpeg',
};

const createQueryString = (parameters) =>
  Object.keys(parameters)
    .sort()
    .map((name) => `${name}=${parameters[name]}`)
    .join('&');

/**
 * Generates image sources and src for the picture element using breakpoints.
 * @param {String} url Base image without parameter.
 * @param {Object} breakpoints Image breakpoints to generate the sources. It helps to generate 1x, 2x and 3x sources.
 * The object keys represents each breakpoint to create it.
 * @param {Object} formats (Optional) Supported formats.
 * @param {Object} irsParameters Image Resize Service parameter. Exclude size parameters like (width, height)
 * and format.
 *
 * @returns {Object} with two properties: sources and @{Array} with all the sources
 * Also src representing the image URL of img tag.
 */
const createPictureImageSources = ({ url, breakpoints = {}, formats = defaultFormats, irsParameters = {} }) => {
  const sources = Object.keys(formats).reduce((acc, format) => {
    const formattedSources = Object.keys(breakpoints).reduce((srcset, breakpoint) => {
      const parameters = { ...breakpoints[breakpoint], ...irsParameters, format };
      const queryString = createQueryString(parameters);
      return `${srcset}${url}?${queryString} ${breakpoint}, `;
    }, '');

    // Remove trailing comma and space from the final srcset
    acc.push({ srcset: formattedSources.slice(0, -2), format: formats[format] });
    return acc;
  }, []);

  const sizing = Object.values(breakpoints)[0] ?? {};
  const parameters = { ...sizing, ...irsParameters, format: 'jpg' };
  const queryString = createQueryString(parameters);
  const src = `${url}?${queryString}`;
  return { sources, src };
};

export default createPictureImageSources;
